import React, { useContext, useEffect } from 'react';
import { track } from '../../analytics/analytics';
import { EventIDs } from '../../analytics/events';
import { COMING_SOON_BANNER, NOTIF_ILLUSTRATION } from '../../constants/urls';
import { UserContext } from '../context/userContext';
import {
    ComingSoonImg,
    InvoiceDiv,
    InvoiceImg,
    InvoiceContainer,
    HeaderText,
    IllustrationText,
  } from './styles';

const Alerts = () =>{
    const { businessDetails,email } = useContext<Record<string, any>>(
        UserContext
      );

    useEffect(() => {
        businessDetails.addPageName('ALERTS');
        const payload={
          email,
        }
        track(EventIDs.INVOICES_PAGE,payload)
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    return(
    <InvoiceContainer index={0}>
      <InvoiceDiv>
        <ComingSoonImg src={COMING_SOON_BANNER} alt="" />
        <InvoiceImg src={NOTIF_ILLUSTRATION} alt="" />
        <HeaderText>Get Instant Notifications </HeaderText>
        <IllustrationText>
        Get instant notifications and important alerts.
        </IllustrationText>
      </InvoiceDiv>
    </InvoiceContainer>
    );
}

export default Alerts
